/** Monio Cluster Manufacturers — brand assets & palette */
export const BRAND = {
  name: 'Monio Cluster',
  subtitle: 'Manufacturers',
  tagline: 'Believe when you see',
  furnitureTagline: 'Redefining comfort for your living room',
  colors: {
    navy: '#1b4d89',
    navyDark: '#0f3460',
    navyLight: '#2d6cb5',
    cream: '#f2e9dc',
    creamLight: '#faf6f0',
    white: '#ffffff',
  },
  images: {
    logo: '/images/brand/logo-3d.png',
    teamSign: '/images/brand/team-sign.png',
    teamFacility: '/images/brand/team-facility.png',
    furniture: '/images/brand/furniture-showcase.png',
    facilityExterior: '/images/brand/facility-exterior.png',
    gateSign: '/images/brand/gate-sign.png',
    outdoorSign: '/images/brand/outdoor-sign.png',
  },
} as const;

export const BRAND_SERVICES = [
  {
    title: 'Textile Manufacturing',
    description: 'Premium fabrics, apparel, and industrial textiles crafted with precision and sustainable practices.',
    image: BRAND.images.teamSign,
    category: 'Textiles',
  },
  {
    title: 'Smart Furniture',
    description: 'Modern furniture designed for comfort, durability, and contemporary living spaces.',
    image: BRAND.images.furniture,
    category: 'Furniture',
  },
  {
    title: 'Metalworks & Engineering',
    description: 'Precision metal fabrication and industrial components built to international standards.',
    image: BRAND.images.facilityExterior,
    category: 'Metalworks',
  },
  {
    title: 'Footwear & Accessories',
    description: 'Quality footwear production with attention to design, fit, and lasting craftsmanship.',
    image: BRAND.images.teamFacility,
    category: 'Footwear',
  },
];

export const BRAND_MOSAIC = [
  { src: BRAND.images.facilityExterior, alt: 'Monio Cluster facility entrance', span: 'large' as const },
  { src: BRAND.images.teamSign, alt: 'Monio Cluster team at facility', span: 'medium' as const },
  { src: BRAND.images.gateSign, alt: 'Monio Cluster gate signage', span: 'small' as const },
  { src: BRAND.images.furniture, alt: 'Monio Cluster furniture showcase', span: 'medium' as const },
  { src: BRAND.images.outdoorSign, alt: 'Monio Cluster outdoor sign', span: 'small' as const },
  { src: BRAND.images.teamFacility, alt: 'Monio Cluster manufacturing team', span: 'medium' as const },
];
